(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("immutable"));
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["FluxThis"] = factory(require(undefined));
	else
		root["FluxThis"] = factory(root[undefined]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_66__) {
return 


/** WEBPACK FOOTER **
 ** webpack/universalModuleDefinition
 **/